import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { generateReport } from '../../app/store/actions/reports';
import FilterDefault from '../../components/filters/FilterDefault';
import OneClickButton from '../../components/form/button';
import Form from '../../components/form/form';
import DualList from '../../components/pages/DualList';
import { PanelPage } from '../../components/pages/pages';
import { returnFiltersByRules } from './utils';
import ROUTES from '../../config/routes';
import ReportsBackgroundModal from '../../components/pages/reportsBackgroundModal';

class ReportMovementExpeditionOutboundOrdersItemsSerialList extends React.PureComponent {
  constructor() {
    super();

    this.breadcrumb = [
      {
        value: (
          <>
            <i className="fas fa-home fa-fw m-t-10 m-r-5" />
            {' '}
            {I18n.t('BEE12' /* Início */)}
          </>),
      },
      { value: I18n.t('BEE47' /* Relatórios */) },
      { value: I18n.t('BEE1400' /* Movimentação */) },
      { value: I18n.t('BEE41' /* Expedição */) },
      { value: I18n.t('BEE4814' /* Itens controlados por serial */), active: true },
    ];

    this.options = [
      {
        label: I18n.t('BEE443' /* Documento */),
        value: 'orderNumber',
      }, {
        label: I18n.t('BEE1994' /* Código Filial */),
        value: 'branchCode',
      }, {
        label: I18n.t('BEE1997' /* Nome Filial */),
        value: 'branchName',
      }, {
        label: I18n.t('BEE432' /* Endereço */),
        value: 'branchAddress',
      }, {
        label: I18n.t('BEE53' /* Cidade */),
        value: 'branchCity',
      }, {
        label: I18n.t('BEE87' /* Estado */),
        value: 'branchState',
      }, {
        label: I18n.t('BEE119' /* CEP */),
        value: 'branchPostalCode',
      }, {
        label: I18n.t('BEE352' /* Nome Fantasia */),
        value: 'customerBusinessName',
      }, {
        label: `${I18n.t('BEE50' /* Cliente */)} - ${I18n.t('BEE432' /* Endereço */)}`,
        value: 'customerAddress',
      }, {
        label: `${I18n.t('BEE50' /* Cliente */)} - ${I18n.t('BEE53' /* Cidade */)}`,
        value: 'customerCity',
      }, {
        label: `${I18n.t('BEE50' /* Cliente */)} - ${I18n.t('BEE87' /* Estado */)}`,
        value: 'customerState',
      }, {
        label: `${I18n.t('BEE50' /* Cliente */)} - ${I18n.t('BEE119' /* CEP */)}`,
        value: 'customerPostalCode',
      }, {
        label: I18n.t('BEE88' /* País */),
        value: 'customerCountry',
      }, {
        label: I18n.t('BEE377' /* Código de Barras */),
        value: 'ean',
      }, {
        label: I18n.t('BEE4815' /* Serial do Item */),
        value: 'productSerial',
      }, {
        label: I18n.t('BEE463' /* Linha */),
        value: 'lineNumber',
      }, {
        label: I18n.t('BEE402' /* Nota Fiscal */),
        value: 'invoiceNumber',
      }, {
        label: `${I18n.t('BEE402' /* Nota Fiscal */)} - ${I18n.t('BEE2280' /* Data Emissão */)}`,
        value: 'invoiceDate',
      }, {
        label: `${I18n.t('BEE1369' /* Romaneio */)} - ${I18n.t('BEE2280' /* Data Emissão */)}`,
        value: 'waybillCreatedAt',
      },
    ];

    this.state = {
      selected: [],
      customerCodeFrom: '',
      customerCodeTo: '',
      orderNumberFrom: '',
      orderNumberTo: '',
      checkedAtFrom: '',
      checkedAtTo: '',
      invoiceNumberFrom: '',
      invoiceNumberTo: '',
      productSerial: '',
      productCodeFrom: '',
      productCodeTo: '',
    };
  }

  onChangeDualList = (selected) => {
    this.setState({ selected });
  };

  setValue = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value,
    });
  };

  onGenerateSpreadsheet = () => {
    const {
      selected,
      customerCodeFrom,
      customerCodeTo,
      orderNumberFrom,
      orderNumberTo,
      checkedAtFrom,
      checkedAtTo,
      invoiceNumberFrom,
      invoiceNumberTo,
      productSerial,
      productCodeFrom,
      productCodeTo,
    } = this.state;

    const { location } = this.props;
    const headers = selected.map((it) => ({ ...(this.options.find((itb) => itb.value === it) || {}) }));

    const filterRules = [
      ['customerCode', { type: 'between', value: [customerCodeFrom, customerCodeTo] }],
      ['orderNumber', { type: 'between', value: [orderNumberFrom, orderNumberTo] }],
      ['checkedAt', { type: 'between', value: [checkedAtFrom, checkedAtTo] }],
      ['invoiceNumber', { type: 'between', value: [invoiceNumberFrom, invoiceNumberTo] }],
      ['productCode', { type: 'between', value: [productCodeFrom, productCodeTo] }],
    ];

    if (productSerial) {
      filterRules.push(['productSerial', { type: 'like', value: `%${productSerial}%` }]);
    }

    const filters = returnFiltersByRules(filterRules);

    this.props.generateReport(
      I18n.t('BEE4817' /* Itens controlados por Serial */).toLowerCase(),
      'xlsx',
      location.pathname,
      headers,
      filters,
    );
  };

  onSelectFilter = (newState) => {
    this.setState({ ...newState });
  };

  render() {
    const {
      selected,
      customerCodeFrom,
      customerCodeTo,
      orderNumberFrom,
      orderNumberTo,
      checkedAtFrom,
      checkedAtTo,
      invoiceNumberFrom,
      invoiceNumberTo,
      productSerial,
      productCodeFrom,
      productCodeTo,
    } = this.state;

    const { location = {} } = this.props;

    return (
      <PanelPage
        breadcrumb={this.breadcrumb}
        title={`${I18n.t('BEE528' /* Relatório */)} -
          ${I18n.t('BEE4814' /* Documentos com Itens controlados por Serial */)}`}
        wikiHelp={ROUTES.REPORT_HELP}
        content={(
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <FilterDefault stateToSave={this.state} route={location.pathname} onSelectFilter={this.onSelectFilter} />
            <div className="d-flex mb-md-4 mb-4 mt-4" />
            <DualList
              id="dualselect"
              options={this.options}
              selected={selected}
              onChange={this.onChangeDualList}
              preserveSelectOrder
              showOrderButtons
              showHeaderLabels
            />
            <div className="d-flex align-items-center mb-md-3 mb-1 mt-5">
              <h1 className="page-header mb-0">
                {I18n.t('BEE546' /* Filtros */)}
              </h1>
            </div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createInputRange(
                    { from: customerCodeFrom, to: customerCodeTo },
                    { from: 'customerCodeFrom', to: 'customerCodeTo' },
                    `${I18n.t('BEE50' /* Cliente */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                  formContext.createInputRange(
                    { from: orderNumberFrom, to: orderNumberTo },
                    { from: 'orderNumberFrom', to: 'orderNumberTo' },
                    `${I18n.t('BEE443' /* Documento */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                  formContext.createDateInputRange(
                    { from: checkedAtFrom, to: checkedAtTo },
                    { from: 'checkedAtFrom', to: 'checkedAtTo' },
                    `${I18n.t('BEE467' /* Data Conferência */)}:`,
                    { from: '', to: '__/__/____' },
                  ),
                  formContext.createInputRange(
                    { from: invoiceNumberFrom, to: invoiceNumberTo },
                    { from: 'invoiceNumberFrom', to: 'invoiceNumberTo' },
                    `${I18n.t('BEE402' /* Nota Fiscal */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                  formContext.createInput(
                    productSerial,
                    'productSerial',
                    `${I18n.t('BEE4815' /* Serial do Item */)}:`,
                    '',
                    'text',
                    false,
                    false,
                    undefined,
                    4,
                  ),
                  formContext.createInputRange(
                    { from: productCodeFrom, to: productCodeTo },
                    { from: 'productCodeFrom', to: 'productCodeTo' },
                    `${I18n.t('BEE225' /* Produto */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                ])}
              />
            </div>
            <ReportsBackgroundModal />
          </div>
        )}
        footerContent={(
          <OneClickButton
            type="button"
            style={{ width: 'auto', padding: 10 }}
            className="btn btn-primary p-5 m-5"
            onClick={this.onGenerateSpreadsheet}
          >
            {I18n.t('BEE544' /* Gerar Planilha */)}
          </OneClickButton>
        )}
      />
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  generateReport:
    (nameDoc, type, route, columns, filters) => dispatch(generateReport(nameDoc, type, route, columns, filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportMovementExpeditionOutboundOrdersItemsSerialList);
